import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRegisterDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M5 15.5C5 15.5 6 14.5 9 14.5C12 14.5 13 16.5 16 16.5C19 16.5 20 15.5 20 15.5V4.5C20 4.5 19 5.5 16 5.5C13 5.5 12 3.5 9 3.5C6 3.5 5 4.5 5 4.5V15.5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M5 21V15.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
export default SvgRegisterDefault;
